import { render } from "./History.vue?vue&type=template&id=0bcd880e&scoped=true&ts=true"
import script from "./History.vue?vue&type=script&lang=ts"
export * from "./History.vue?vue&type=script&lang=ts"

import "./History.vue?vue&type=style&index=0&id=0bcd880e&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/spark-cabinet-redesigned/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcd880e"]])

export default __exports__